/**
 * VM Status Badge Component
 */

import React from 'react';
import { VMStatus } from '../../types/vm';

interface VMStatusBadgeProps {
  status: VMStatus;
}

const statusColors: Record<VMStatus, string> = {
  pending: 'bg-yellow-500/20 text-yellow-400',
  creating: 'bg-blue-500/20 text-blue-400',
  running: 'bg-green-500/20 text-green-400',
  stopping: 'bg-orange-500/20 text-orange-400',
  stopped: 'bg-gray-500/20 text-gray-400',
  error: 'bg-red-500/20 text-red-400',
  deleting: 'bg-red-500/20 text-red-400',
  deleted: 'bg-gray-500/20 text-gray-400',
};

const statusLabels: Record<VMStatus, string> = {
  pending: 'Pending',
  creating: 'Creating',
  running: 'Running',
  stopping: 'Stopping',
  stopped: 'Stopped',
  error: 'Error',
  deleting: 'Deleting',
  deleted: 'Deleted',
};

export const VMStatusBadge: React.FC<VMStatusBadgeProps> = ({ status }) => {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statusColors[status]}`}
    >
      {statusLabels[status]}
    </span>
  );
};







